import React from 'react'
import ImageCard from './ImageCard';
import fallbackImage from '../assets/images/IMG_0120.jpeg';

const ImagesCollection = () => {
    const imagesList = [...new Array(8)].map((number, index) => ({
      src: fallbackImage,
      alt: `collection-${index + 1}`,
    }));
 
   return (
     <>
    <ul className='images-collection-container'>
      {imagesList.map((imgUrl, index) => {
        return (
          <li key={`image-${index}`} className={index % 2 === 0 ? 'item short' : 'item tall'}>
            <figure>
              <ImageCard imgUrl={imgUrl.src} altText={imgUrl.alt} />
            </figure>
          </li>
        );
      })}
    </ul>
    <div className="d-flex mb-2">
      <a href="/" className="mx-auto fs-3">
        View More
      </a>
     </div>
    </>
  );
};

export default ImagesCollection